// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element.css'
import '@/assets/css/schoolWeb.scss'
import "@/assets/css/bootstrap/strap/bootstrap.css";
import '@/assets/script/jquery-3.1.1.min.js'
import '@/assets/css/fullpage/style.css'
import '@/rem/rem.js'
import '@/assets/css/fullpage.min.css'
import '@/assets/css/companyWeb.scss'
import '@/assets/css/productCenter.scss'
import 'swiper/swiper.scss'
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css'
Vue.config.productionTip = false

// import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
Vue.use(VueFullPage);

import "./components/xm-tools/tools";
// import VueResource from 'vue-resource'
import axios from 'axios'

// cookie
import cookie from 'vue-cookies'
// cookie有效时间
Vue.use(cookie)
// Vue.use(VueResource)
Vue.$cookies.config('1d')
// Vue.prototype.$axios = Axios;
Vue.prototype.$http= axios

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js